import ProfileDetails from "../../slices/profile/ProfileDetails";
import FitnessList from "../../slices/profile/FitnessList";

const profileReducer = {
    profileDetails: ProfileDetails,
    fitnessList: FitnessList,
};

export default profileReducer;